export const UOM = [
    { "key": "\"", "value": "Inch" },

    { "key": "\"2", "value": "Square inch" },

    { "key": "\"3", "value": "Cubic inch" },

    { "key": "%", "value": "Percentage" },

    { "key": "O", "value": "Per mille" },

    { "key": "000", "value": "Meter/Minute" },

    { "key": "22S", "value": "Square millimeter/second" },

    { "key": "A", "value": "Ampere" },

    { "key": "ACR", "value": "Acre" },

    { "key": "AU", "value": "Activity unit" },

    { "key": "BAG", "value": "Bag" },

    { "key": "BAR", "value": "bar" },

    { "key": "BOX", "value": "BOX" },

    { "key": "BQK", "value": "Becquerel/kilogram" },

    { "key": "BT", "value": "Bottle" },

    { "key": "BYT", "value": "Bytes" },

    { "key": "C3S", "value": "Cubic centimeter/second" },

    { "key": "CAN", "value": "Canister" },

    { "key": "CAR", "value": "Carton" },

    { "key": "CCM", "value": "Cubic centimeter" },

    { "key": "CD", "value": "Candela" },

    { "key": "CD3", "value": "Cubic decimeter" },

    { "key": "CL", "value": "Centiliter" },

    { "key": "CM", "value": "Centimeter" },

    { "key": "CM2", "value": "Square centimeter" },

    { "key": "CMH", "value": "Centimeter/hour" },

    { "key": "CMS", "value": "Centimeter/second" },

    { "key": "CRT", "value": "Crate" },

    { "key": "CV", "value": "Case" },

    { "key": "D", "value": "Days" },

    { "key": "DAY", "value": "Days" },

    { "key": "DEG", "value": "Degree" },

    { "key": "DM", "value": "Decimeter" },

    { "key": "DR", "value": "Drum" },

    { "key": "DRR", "value": "cProjects:Unit f.Req.Capcty" },

    { "key": "DZ", "value": "Dozen" },

    { "key": "EA", "value": "each" },

    { "key": "EML", "value": "Enzyme Units / Mi	lliliter" },

    { "key": "EU", "value": "Enzyme Units" },

    { "key": "F", "value": "Farad" },

    { "key": "FOZ", "value": "Fluid Ounce 	US" },

    { "key": "FT", "value": "Foot" },

    { "key": "FT2", "value": "Square foot" },

    { "key": "FT3", "value": "Cubic foot" },

    { "key": "G", "value": "Gram" },

    { "key": "G", "value": "L | gram act.rd/liter" },

    { "key": "GAI", "value": "Gram act.ingrd." },

    { "key": "GAL", "value": "US gallon" },

    { "key": "GAU", "value": "Gram Gold" },

    { "key": "GHG", "value": "Gram / hectogram" },

    { "key": "GJ", "value": "Gigajoule" },

    { "key": "GKG", "value": "Gram / kilogram" },

    { "key": "GLI", "value": "Gram / liter" },

    { "key": "GM", "value": "Gram / Mol" },

    { "key": "GM2", "value": "Gram/squaremeter" },

    { "key": "GM3", "value": "Gram/Cubicmeter" },

    { "key": "GOH", "value": "Gigaohm" },

    { "key": "GPH", "value": "Gallons per hour(US)" },

    { "key": "GPM", "value": "Gallons per mile(US)" },

    { "key": "GRO", "value": "Gross" },

    { "key": "H", "value": "Hour" },

    { "key": "HA", "value": "Hectare" },

    { "key": "HL", "value": "Hectoliter" },

    { "key": "HPA", "value": "Hectopascal" },

    { "key": "HR", "value": "Hours" },

    { "key": "HZ", "value": "Hertz(1/second)" },

    { "key": "IB", "value": "Pikofarad" },

    { "key": "J", "value": "Joule" },

    { "key": "JKG", "value": "Joule / Kilogram" },

    { "key": "JKK", "value": "Spec.Heat Capacity" },

    { "key": "JMO", "value": "Joule / Mol" },

    { "key": "K", "value": "Kelvin" },

    { "key": "KA", "value": "Kiloampere" },

    { "key": "KAI", "value": "Kilogram act.ingrd." },

    { "key": "KBK", "value": "Kilobecquerel / kilogram" },

    { "key": "KD3", "value": "Kilogram / cubic decimeter" },

    { "key": "KG", "value": "Kilogram" },

    { "key": "KGF", "value": "Kilogram / Square meter" },

    { "key": "KGK", "value": "Kilogram / Kilogram" },

    { "key": "KGM", "value": "Kilogram / Mol" },

    { "key": "KGS", "value": "Kilogram / second" },

    { "key": "KGV", "value": "Kilogram / cubicmeter" },

    { "key": "KHZ", "value": "Kilohertz" },

    { "key": "KIK", "value": "kg act.ingrd. / k	g" },

    { "key": "KJ", "value": "Kilojoule" },

    { "key": "KJK", "value": "Kilojoule / kilogram" },

    { "key": "KJM", "value": "Kilojoule / Mol" },

    { "key": "KM", "value": "Kilometer" },

    { "key": "KM2", "value": "Square kilom	eter" },

    { "key": "KMH", "value": "Kilometer / hour" },

    { "key": "KMK", "value": "Cubic meter / Cubicmeter" },

    { "key": "KMN", "value": "Kelvin / Minute" },

    { "key": "KMS", "value": "Kelvin / Second" },

    { "key": "KOH", "value": "Kiloohm" },

    { "key": "KPA", "value": "Kilopascal" },

    { "key": "KT", "value": "Kilotonne" },

    { "key": "KV", "value": "Kilovolt" },

    { "key": "KVA", "value": "Kilovoltampere" },

    { "key": "KW", "value": "Kilowatt" },

    { "key": "KWH", "value": "Kilowatt hours" },

    { "key": "L", "value": "Liter" },

    { "key": "LB", "value": "US pound" },

    { "key": "LHK", "value": "Liter per 100 km" },

    { "key": "LMI", "value": "Liter / Minute" },

    { "key": "LMS", "value": "Liter / Molsecond" },

    { "key": "LPH", "value": "Liter per hour" },

    { "key": "M", "value": "Meter" },

    { "key": "M%", "value": "Percent mass" },

    { "key": "M%O", "value": "Permille mass" },

    { "key": "M-2", "value": "1 /squaremeter" },

    { "key": "M/H", "value": "Meter/Hour" },

    { "key": "M/L", "value": "Mol per liter" },

    { "key": "M/M", "value": "Mol per cubicmeter" },

    { "key": "M/S", "value": "Meter/second" },

    { "key": "M2", "value": "Square meter" },

    { "key": "M2S", "value": "Square meter / second" },

    { "key": "M3", "value": "Cubic meter" },

    { "key": "M3H", "value": "Cubic meter / Hour" },

    { "key": "M3S", "value": "Cubic meter / second" },

    { "key": "MA", "value": "Milliampere" },

    { "key": "MBA", "value": "Millibar" },

    { "key": "MBZ", "value": "Meterbar / second" },

    { "key": "MEJ", "value": "Megajoule" },

    { "key": "MG", "value": "Milligram" },

    { "key": "MGE", "value": "Milligram / Square centimeter" },

    { "key": "MGG", "value": "Milligram / gram" },

    { "key": "MGK", "value": "Milligram / kilogram" },

    { "key": "MGL", "value": "Milligram / liter" },

    { "key": "MGO", "value": "Megohm" },

    { "key": "MGQ", "value": "Milligram / cubic meter" },

    { "key": "MGW", "value": "Megawatt" },

    { "key": "MHV", "value": "Megavolt" },

    { "key": "MHZ", "value": "Megahertz" },

    { "key": "MI", "value": "Mile" },

    { "key": "MI2", "value": "Square mile" },

    { "key": "MIJ", "value": "Millijoule" },

    { "key": "MIN", "value": "Minute" },

    { "key": "MIS", "value": "Microsecond" },

    { "key": "ML", "value": "Milliliter" },

    { "key": "MLI", "value": "Milliliter act.ingr." },

    { "key": "MLK", "value": "Milliliter / cubic meter" },

    { "key": "MM", "value": "Millimeter" },

    { "key": "MM2", "value": "Square millimeter" },

    { "key": "MM3", "value": "Cubic millimeter" },

    { "key": "MMA", "value": "Millimeter / year" },

    { "key": "MMG", "value": "Millimol / gram" },

    { "key": "MMH", "value": "Millimeter / hour" },

    { "key": "MMK", "value": "Millimol / kilogram" },

    { "key": "MMO", "value": "Millimol" },

    { "key": "MMS", "value": "Millimeter / second" },

    { "key": "MN", "value": "Meganewton" },

    { "key": "MNM", "value": "Millinewton / meter" },

    { "key": "MOK", "value": "Mol / kilogram" },

    { "key": "MOL", "value": "Mol" },

    { "key": "MON", "value": "Months" },

    { "key": "MPA", "value": "Megapascal" },

    { "key": "MPB", "value": "Mass parts per billion" },

    { "key": "MPG", "value": "Miles per gallon(US)" },

    { "key": "MPL", "value": "Millimol perliter" },

    { "key": "MPM", "value": "Mass parts per million" },

    { "key": "MPS", "value": "Millipascal seconds" },

    { "key": "MPT", "value": "Mass parts per trillion" },

    { "key": "MPZ", "value": "Meterpascal / second" },

    { "key": "MS2", "value": "Meter / second squared" },

    { "key": "MSC", "value": "Microsiemens per centimeter" },

    { "key": "MSE", "value": "Millisecond" },

    { "key": "MTE", "value": "Millitesla" },

    { "key": "MV", "value": "Millivolt" },

    { "key": "MVA", "value": "Megavoltampere" },

    { "key": "MW", "value": "Milliwatt" },

    { "key": "MWH", "value": "Megawatt hour" },

    { "key": "N", "value": "Newton" },

    { "key": "NA", "value": "Nanoampere" },

    { "key": "NAM", "value": "Nanometer" },

    { "key": "NI", "value": "Kilonewton" },

    { "key": "NM", "value": "Newton / meter" },

    { "key": "NMM", "value": "Newton / Square millimeter" },

    { "key": "NS", "value": "Nanosecond" },

    { "key": "OCM", "value": "Spec.Elec.Resistance" },

    { "key": "OHM", "value": "Ohm" },

    { "key": "OM", "value": "Spec.Elec.Resistance" },

    { "key": "ONE", "value": "One" },

    { "key": "OZ", "value": "Ounce" },

    { "key": "P", "value": "Points" },

    { "key": "P10", "value": "OuterPAC10" },

    { "key": "P11", "value": "OuterPAC11" },

    { "key": "P12", "value": "OuterPAC12" },

    { "key": "P13", "value": "OuterPAC13" },

    { "key": "P14", "value": "OuterPAC14" },

    { "key": "P15", "value": "OuterPAC15" },

    { "key": "P16", "value": "OuterPAC16" },

    { "key": "P17", "value": "OuterPAC17" },

    { "key": "P18", "value": "OuterPAC18" },

    { "key": "P19", "value": "OuterPAC19" },

    { "key": "P20", "value": "OuterPAC20" },

    { "key": "PA", "value": "Pascal" },

    { "key": "PAA", "value": "Pair" },

    { "key": "PAC", "value": "Pack" },

    { "key": "PAL", "value": "Pallet" },

    { "key": "PAR", "value": "Workers" },

    { "key": "PAS", "value": "Pascal second" },

    { "key": "PDA", "value": "Consultant Days" },

    { "key": "PK1", "value": "Outer PAC1" },

    { "key": "PK2", "value": "Outer PAC2" },

    { "key": "PK3", "value": "Outer PAC3" },

    { "key": "PK4", "value": "Outer PAC4" },

    { "key": "PK5", "value": "Outer PAC5" },

    { "key": "PK6", "value": "Outer PAC6" },

    { "key": "PK7", "value": "Outer PAC7" },

    { "key": "PK8", "value": "Outer PAC8" },

    { "key": "PK9", "value": "Outer PAC9" },

    { "key": "PMI", "value": "1 / minute" },

    { "key": "PMR", "value": "Permeation Rate SI" },

    { "key": "PPB", "value": "Parts per billion" },

    { "key": "PPM", "value": "Parts per million" },

    { "key": "PPT", "value": "Parts per trillion" },

    { "key": "PRC", "value": "Group proportion" },

    { "key": "PRM", "value": "Permeation Rate" },

    { "key": "PRS", "value": "Number of Persons" },

    { "key": "PS", "value": "Picosecond" },

    { "key": "PT", "value": "Pint, US liquid" },

    { "key": "QML", "value": "Kilomol" },

    { "key": "QT", "value": "Quart, US liquid" },

    { "key": "R-U", "value": "Nanofarad" },

    { "key": "RF", "value": "Millifarad" },

    { "key": "RHO", "value": "Gram / cubic centimeter" },

    { "key": "ROL", "value": "Role" },

    { "key": "S", "value": "Second" },

    { "key": "S/M", "value": "Siemens per meter" },

    { "key": "SEC", "value": "Second" },

    { "key": "SET", "value": "SET" },

    { "key": "ST", "value": "items" },

    { "key": "TC3", "value": "1 / cubic centimeter" },

    { "key": "TES", "value": "Tesla" },

    { "key": "TM", "value": "Tomato UOM(EA)" },

    { "key": "TM3", "value": "1 / cubic meter" },

    { "key": "TO", "value": "Tonne" },

    { "key": "TOM", "value": "Ton / Cubic meter" },

    { "key": "TON", "value": "US ton" },

    { "key": "TS", "value": "Thousands" },

    { "key": "V", "value": "Volt" },

    { "key": "V%", "value": "Percent volume" },

    { "key": "VO", "value": "Permille volume" },

    { "key": "VAL", "value": "Value - only material" },

    { "key": "VAM", "value": "Voltampere" },

    { "key": "VPB", "value": "Volume parts per billion" },

    { "key": "VPM", "value": "Volume parts per million" },

    { "key": "VPT", "value": "Volume parts per trillion" },

    { "key": "W", "value": "Watt" },

    { "key": "WK", "value": "Weeks" },

    { "key": "WKY", "value": "Evaporation Rate" },

    { "key": "WMK", "value": "Heat Conductivity" },

    { "key": "YD", "value": "Yards" },

    { "key": "YD2", "value": "Square Yard" },

    { "key": "YD3", "value": "Cubic yard" },

    { "key": "YR", "value": "Years" },

    { "key": "ZC2", "value": "Each Clearance UOM - 2" },

    { "key": "ZC3", "value": "Each Clearance UOM - 3" },

    { "key": "ZC4", "value": "Each Clearance UOM - 4" },

    { "key": "ZC5", "value": "Each Clearance UOM - 5" },

    { "key": "ZC6", "value": "Each Clearance UOM - 6" },

    { "key": "ZC7", "value": "Each Clearance UOM - 7" },

    { "key": "ZC8", "value": "Each Clearance UOM - 8" },

    { "key": "ZCC", "value": "Credit Card" },

    { "key": "ZCL", "value": "Each Clearance UOM" },

    { "key": "ZEA", "value": "Alternative UOM for Each" },

    { "key": "ZIB", "value": "Cosmo Box Of fer" },

    { "key": "ZPA", "value": "Parcel" },

    { "key": "ZPO", "value": "1 + 1 Offer UOM" },

    { "key": "ZSS", "value": "Each Clearance Sale.thru.SAP" },

    { "key": "bbl", "value": "British Thermal Unit / US Barrel" },

    { "key": "bft", "value": "British Thermal Unit / Cubic Ft" },

    { "key": "bgl", "value": "British Thermal Unit / US Gallon" },

    { "key": "btl", "value": "British Thermal Unit / US Pound" },

    { "key": "gj3", "value": "Gigajoule / 1000 Cubic Meters" },

    { "key": "gjm", "value": "Gigajoule / Cubic Meter" },

    { "key": "gjt", "value": "Gigajoule / US Tonne" },

    { "key": "jm3", "value": "Joule / Cubic Meter" },

    { "key": "kgb", "value": "Kilogram / US	Barrel" },

    { "key": "kgj", "value": "Kilogram / Joule" },

    { "key": "kgm", "value": "Kilogram / Million BTU" },

    { "key": "kgs", "value": "Kilogram / Standard Cubic Foot" },

    { "key": "kgt", "value": "Kilogram / US Tonne" },

    { "key": "kml", "value": "Kilogram / Kilogram Mole" },

    { "key": "lbb", "value": "US Pound / British Thermal Unit" },

    { "key": "lbg", "value": "US Pound / US Gallon" },

    { "key": "lbl", "value": "US Pound / US Pound Mole" },

    { "key": "lbm", "value": "US Pound / Million BTU" },

    { "key": "lbs", "value": "US Pound / Standard Cubic Foot" },

    { "key": "lbt", "value": "US Pound / US Tonne" },

    { "key": "mbb", "value": "Million BTU / US Barrel" },

    { "key": "mbt", "value": "Million BTU / US Tonne" },

    { "key": "tbl", "value": "Tonne / US Barrel" },

    { "key": "tbt", "value": "Tonne / British Thermal Unit" },

    { "key": "tgl", "value": "US Tonne / US Gallon" },

    { "key": "tjl", "value": "Tonne / Joule" },

    { "key": "tm3", "value": "Tonne / 1000 Cubic Meters" },

    { "key": "tt", "value": "Tonne / Tonne" },

    { "key": "ttj", "value": "Tonne / Terajoule" },

    { "key": "?C", "value": "Degrees Celsius" },

    { "key": "?F", "value": "Fahrenheit" },

    { "key": "?A", "value": "Microampere" },

    { "key": "?F", "value": "Microfarad" },

    { "key": "?GL", "value": "Microgram / liter" },

    { "key": "?GQ", "value": "Microgram / cubic meter" },

    { "key": "?L", "value": "Microliter" },

    { "key": "?M", "value": "Micrometer" }
]